import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    topBarContainer: {
        justifyContent: "space-between",
        alignItems: "center",
        flexDirection: "row",
        width: "100%"
    },
    headerContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    emptyContainer: {
        justifyContent: "center",
        alignItems: "center"
    },
    modalOverlay: {
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        width: "100%",
        flex: 1
    },
    languageSwitcher: {
        flexDirection: "row",
        alignItems: "center"
    },
    modalCloseButton: {
        position: "absolute",
        zIndex: 10
    },
    metaContainer: {
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap"
    },
    topBarActions: {
        alignItems: "center",
        flexDirection: "row"
    },
    metaItem: {
        flexDirection: "row",
        alignItems: "center"
    },
    coverImage: {
        alignSelf: "center",
        aspectRatio: 16 / 9,
        maxHeight: 520,
        width: "100%"
    },
    galleryThumbnail: {
        aspectRatio: 16 / 9,
        height: 130
    },
    galleryContainer: {
        width: "100%"
    },
    contentContainer: {
        width: "100%"
    },
    lightboxImage: {
        height: "100%",
        width: "100%"
    }
});
export default stylesheet;
